// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:28:02

export default {
  "id": "find-sort-match",
  "slug": "find-sort-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/dc0c7ce2762e4c17a5d4e0de56705f65-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/dc0c7ce2762e4c17a5d4e0de56705f65/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Find Sort Match",
      "description": " Find Sort Match is a fun and creative puzzle that combines sort and match elements. Let you experience the joy of DIY! In the game, sort and match items of various shapes, colors, and types. And complete each level of the challenge.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "math",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "找到排序匹配",
      "description": "《寻序匹配》是一款有趣且富有创意的拼图游戏，结合了排序和匹配元素。让你体验DIY的乐趣！在游戏中，你需要对各种形状、颜色和类型的物品进行排序和匹配。并完成每一个挑战关卡。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "拼图"
      ],
      "tags": [
        "数学",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "尋找排序匹配",
      "description": "尋找排序配對是一款有趣且創意的拼圖遊戲，結合了排序和配對元素。讓你體驗DIY的樂趣！在遊戲中，對各種形狀、顏色和類型的物品進行排序和配對。並完成每個挑戰關卡。",
      "instructions": "鼠標點擊或滑動按鍵開始遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "數學",
        "排序"
      ]
    },
    "zh-HK": {
      "title": "尋找配對排序",
      "description": "尋找排序配對是一款充滿趣味及創意的拼圖遊戲，結合排序及配對元素。讓你體驗DIY的樂趣！在遊戲中，對各種形狀、顏色及類型的物品進行排序及配對。並完成挑戰的每一關。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "數學",
        "排序"
      ]
    },
    "ja": {
      "title": "フィンジン ソート マッチ",
      "description": "Find Sort Matchは、並べ替えと一致させる要素を組み合わせた楽しい創造的なパズルです。DIYの喜びを体験させます！ゲームでは、様々な形、色、タイプのアイテムを並べ替え、一致させ、挑戦の各レベルをクリアしてください。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "数学",
        "ソート"
      ]
    },
    "ko": {
      "title": "찾아서 정렬 매치",
      "description": "파인드 솔트 매치는 재미있고 창의적인 파ズ럴 게임으로 정렬과 매칭 요소를 결합한 게임입니다. 나만의 독특한 DIY의 즐거움을 경험해보세요! 게임에서 다양한 형상, 색상, 유형의 아이템을 정렬하고 매칭하여 각 레벨의 도전을 완료하세요.",
      "instructions": "마우스 클릭이나 탭하여 게임을 시작하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "수학",
        "정렬"
      ]
    },
    "fr": {
      "title": "Trouver la correspondance par ordre",
      "description": "Find Sort Match est un puzzle amusant et créatif qui combine des éléments de tri et de correspondance. Permettez-vous de vivre le bonheur du DIY ! Dans le jeu, triez et correspondez des objets de diverses formes, couleurs et types. Et terminez chaque niveau du défi.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "mathématiques",
        "tri"
      ]
    }
  }
};
